import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { uploadUrl } from "../hooks/uploadUrl";
import { AppContext } from "../context/context";

const UploadUrlModal = ({ setUploadUrlModalOpen }) => {
  //url regex
  let urlRegex =
    /^(https?:\/\/)?([a-zA-Z0-9]+([a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\/\.]+)*\/?$/;

  //global state
  const { fetchDocuments, state } = useContext(AppContext);

  //loading state for disabling events
  const [loading, setLoading] = useState(false);

  //paylaod urls
  const [urls, setUrls] = useState([
    {
      text: "",
      isValid: false
    }
  ]);

  //handle add url
  const handleAddUrl = () => {
    let tempArr = [...urls];
    tempArr.push({
      text: "",
      isValid: true
    });
    setUrls(tempArr);
  };

  //handle close modal
  const handleClose = () => {
    setUploadUrlModalOpen(false);
  };

  //handle submit/upload urls
  const handleSubmit = async () => {
    toast.dismiss();

    //checking if all urls are valid
    if (urls.every((url) => url.isValid === true)) {
      let toastId = toast.loading("loading...");
      setLoading(true);

      // filtering unique urls
      let uniqueUrls = urls.filter(
        (obj, index, self) =>
          index === self.findIndex((t) => t.text === obj.text) &&
          obj.text !== ""
      );
      // uploading urls in a loop
      for (const url of uniqueUrls) {
        try {
          let data = await uploadUrl(url.text, state?.activeTab);
          toast.dismiss(toastId);
          if (data.status === "Docs uploaded successfully.") {
            toast.success(`URL(${url.text}) uploaded successfully.`);
          } else {
            toast.error(`URL (${url.text}) ${data.status ? data.status : ""}`);
          }
        } catch (err) {
          console.log("Error: ", err);
        }
      }

      //closing modal and
      setLoading(false);
      setUploadUrlModalOpen(false);

      //refetching updated urls
      fetchDocuments(state?.activeTab);
    }
  };

  // handle change url input fiels
  const handleUrlChange = (e, i) => {
    setUrls((prev) => {
      let tempUrls = [...prev];
      tempUrls[i] = {
        text: e.target.value,
        isValid:
          e.target.value.length > 10 ? urlRegex.test(e.target.value) : true
      };
      return tempUrls;
    });
  };

  // validating url on input focus blur
  const handleInputBlur = (e, i) => {
    setUrls((prev) => {
      let tempUrls = [...prev];
      tempUrls[i] = {
        text: tempUrls[i].text,
        isValid:
          tempUrls[i].text === "" ? true : urlRegex.test(tempUrls[i].text)
      };
      return tempUrls;
    });
  };

  return (
    <div className="UploadUrlModal flex items-center justify-center h-full w-screen absolute inset-0 bg-[grey] z-[1] bg-opacity-50">
      <div className="modal bg-white rounded-md p-6 w-[30rem] relative">
        <div
          onClick={handleClose}
          className={`w-7 h-7 p-2 absolute top-[8px] right-[15px] cursor-pointer ${
            loading && "pointer-events-none"
          }`}
        >
          <img className="h-full w-full" src={assetsManager.crossIcon} alt="" />
        </div>
        <div className="modal-header text-center text-xl text-[#424242] font-medium">
          Upload URLs
        </div>
        <div className="modal-body">
          <div>
            <label htmlFor="url" className="text-[#676767] text-sm">
              Paste Link/URl here
            </label>
            <div className="flex gap-2 flex-col max-h-[17rem] overflow-auto">
              {urls.map((url, i) => {
                return (
                  <div className="flex items-center gap-2 h-[2.3rem]" key={i}>
                    <input
                      id={`url-${i}`}
                      className={`w-[calc(100%_-_40px)] ${
                        !url.isValid && url.text !== ""
                          ? "border-[#C7222A] border-2"
                          : "border-[#E3E3E3] border-2"
                      } rounded-[4px] h-full p-2 focus:outline-none text-sm`}
                      name="url-input"
                      value={url.text}
                      placeholder="Enter link here"
                      onChange={(e) => handleUrlChange(e, i)}
                      onBlur={(e) => handleInputBlur(e, i)}
                      disabled={loading}
                    />
                    {urls?.length - 1 === i && !loading && (
                      <div
                        onClick={handleAddUrl}
                        className="h-[1.6rem] w-[1.6rem] flex items-center justify-center bg-[#C7222A] bg-opacity-10 rounded-full cursor-pointer"
                      >
                        <img
                          className="w-[14px]"
                          src={assetsManager.plusIcon}
                          alt=""
                        />
                      </div>
                    )}
                  </div>
                );
              })}
              <AlwaysScrollToBottom />
            </div>
          </div>
          <button
            className="bg-[#C7222A] text-white text-sm flex items-center justify-center w-full h-[39px] mt-3 rounded-[4px] disabled:cursor-not-allowed"
            onClick={handleSubmit}
            disabled={loading || urls.some((url) => url.isValid === false)}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadUrlModal;

//scroll to bottom
const AlwaysScrollToBottom = () => {
  const elementRef = useRef();
  useEffect(() => elementRef.current.scrollIntoView());
  return <div ref={elementRef} />;
};
